import axios from "axios";
import { api } from "constants/RotasAPI";
import { useMutation, useQueryClient } from "react-query";

export const usePutInativarConfiguarcaoBuscaEmail = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (email: string) => {
            const response = await axios.put(
                `${api.groupPay.putinativarConfiguracoesEmail}/${email}`
            );
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries("configuracao-group-pay");
        },
    });
};